import { checkForVaiControllerTransactionError } from 'errors';
import type { TransactionReceipt } from 'web3-core';
import { VaiController, UmiVault } from 'types/contracts';

export interface SetSyndicateRateL1Input {
  umiControllerContract: UmiVault;
  fromAccountAddress: string;
  amountWei: string;
}

export type SetSyndicateRateL1Output = TransactionReceipt;

const setSyndicateRateL1 = async ({
                          umiControllerContract,
  fromAccountAddress,
  amountWei,
}: SetSyndicateRateL1Input): Promise<SetSyndicateRateL1Output> => {
  const resp = await umiControllerContract.methods
    .setSyndicateRateL1(amountWei)
    .send({ from: fromAccountAddress });
  return checkForVaiControllerTransactionError(resp);
};

export default setSyndicateRateL1;
